export type ChartTone = 'muted' | 'red' | 'green' | 'gold';

// Tier thresholds (creators per day):
//   <33 muted, 33–65 red, 66–98 green, ≥99 gold.
export function chartTone(count: number): ChartTone {
  if (count >= 99) return 'gold';
  if (count >= 66) return 'green';
  if (count >= 33) return 'red';
  return 'muted';
}

export const TONE_BAR: Record<ChartTone, string> = {
  muted: 'bg-white/20',
  red: 'bg-brand-red',
  green: 'bg-success',
  gold: 'bg-warning',
};

export const TONE_GLOW: Record<ChartTone, string> = {
  muted: 'rgba(255,255,255,0.18)',
  red: 'rgba(255,68,68,0.4)',
  green: 'rgba(94,254,168,0.4)',
  gold: 'rgba(254,219,94,0.4)',
};

export const THRESHOLDS = [33, 66, 99] as const;
